import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useHWCOrderMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (err: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (data: Partial<Api.IHandwrittenCard>) => {
			return userSession.webServiceHelper.callAsync<any>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `handwrittencard/order` }),
				'POST',
				data
			);
		},
		onError,
		onSuccess,
	});
}
